jQuery(document).ready(function ($) {
  /*
   * Admin menu items hover effect
   */
  $('#adminmenu li.menu-top').hover(
    function () {
      $(this).find('> a').animate({ paddingLeft: '2px' }, 100);
    },
    function () {
      $(this).find('> a').animate({ paddingLeft: '0' }, 100);
    },
  );

  /*
   * Admin notices slide in effect
   */
  $('.notice').hide().slideDown(400);
});
